import * as authentication from "../../common/actions/authentication";
import * as hubOverview from "../actions/hubOverview.js";
import * as hubProduction from "../actions/hubProduction.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        overview :  {
            currentWeekProductionDates: [],
            nextWeekProductionDates: [],
            currentWeekNo : undefined,
            nextWeekNo: undefined,
        },
        customerProductionList : [],
        editedCustomer : {            
            customerId : "",
            products : []
        },
        hubProducts : [],
        productsSorting: false,
        customersSorting: false,
    });
};

/**
 * Fresh food hub reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch (action.type) {
    case hubOverview.SET_HUB_OVERVIEW:
        return state.merge({
            overview: action.payload
        });
    case hubProduction.SET_HUB_PRODUCTION:      
        return state.merge({
            customerProductionList: action.payload
        });
    case hubProduction.SET_HUB_PRODUCTS:      
        return state.merge({
            hubProducts: action.payload
        });
    case hubOverview.SET_SORTING_PRODUCTS:
        return state.merge({
            productsSorting: action.sorting,
        }, {
            deep: true
        });
    case hubOverview.SET_SORTING_CUSTOMERS:
        return state.merge({
            customersSorting: action.sorting,
        }, {
            deep: true
        });
    case hubOverview.SORT_HUB_PRODUCTS:
    {
        const products  = action.thisWeek ?
            state.overview.currentWeekProductionDates[action.dateIndex].plannedProductsForDate :
            state.overview.nextWeekProductionDates[action.dateIndex].plannedProductsForDate;

        const arr = Immutable.asMutable(products);
        const itemToMove = arr[action.index1];
        arr.splice(action.index1,1);
        arr.splice(action.index2,0,itemToMove);

        return Immutable.setIn(state, ["overview", action.thisWeek ? "currentWeekProductionDates" : "nextWeekProductionDates", action.dateIndex, "plannedProductsForDate"], arr);
    }
    case hubOverview.SORT_HUB_CUSTOMERS:
    {
        const customers  = action.thisWeek ?
            state.overview.currentWeekProductionDates[action.dateIndex].customers :
            state.overview.nextWeekProductionDates[action.dateIndex].customers;

        const arr = Immutable.asMutable(customers);
        const itemToMove = arr[action.index1];
        arr.splice(action.index1,1);
        arr.splice(action.index2,0,itemToMove);

        return Immutable.setIn(state, ["overview", action.thisWeek ? "currentWeekProductionDates" : "nextWeekProductionDates", action.dateIndex, "customers"], arr);
    }
    case hubProduction.SET_HUB_PRODUCTION_NEW_PRODUCT:
    {
        // Try to find the customer    
        const index = state.customerProductionList.findIndex( (cus) => cus.customerId===action.customerId);

        if(index !== -1)
        {
            // Add new product
            return Immutable.setIn(state, ["customerProductionList", index, "products"], [action.product].concat(state.customerProductionList[index].products));  
        }
        else return state;
    }       
    case hubProduction.SET_HUB_PRODUCTION_NEW_CUSTOMER:
        return state.merge({
            editedCustomer : {
                customerId : action.customerId,
                products : []
            }
        });    
    case hubProduction.SET_HUB_PRODUCTION_NEWQTY:
    {
        // Try to find the product    
        const index = state.editedCustomer.products.findIndex( (product) => product.productId===action.product.productId);

        if(index === -1)
        {
            // Add new product
            return Immutable.setIn(state, ["editedCustomer", "products"], [action.product].concat(state.editedCustomer.products));
        }
        else {
            // Update qty of existing
            return Immutable.setIn(state, ["editedCustomer", "products", index], action.product);
        }
    }
    case hubProduction.CLEAR_HUB_PRODUCTION_NEWQTY:      
        return state.merge(
            {
                editedCustomer : {            
                    ...state.editedCustomer,
                    products : []
                },
            },
            {
                deep: true
            }
        );
    // case hubProduction.SET_HUB_PRODUCTION_NEWQTY:
    //     return state.merge({
    //         customerProductionList: [...state.customerProductionList.map(customer => 
    //             (customer.customerId === action.customerId ? {
    //                 ...customer,
    //                 products: [customer.products.map(product => product.productId === action.productId ? {
    //                     ... product,
    //                     unconfirmedQty : action.value
    //                 } : product)]
    //             } : customer))]
    //     });    
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}
